import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import webApi from '../webApi'
import { NewsItem } from '../webApi/DataModels'
import { AxiosResponse } from 'axios'
import { map, filter } from 'lodash'
import moment from 'moment'
import constants from '../constants'

class NewsState {
  public news: NewsItem[] = []
}
const mutations = <MutationTree<NewsState>>{
  setNews (state: NewsState, newsItems: NewsItem[]): void {
    state.news = map(newsItems, (newsItem: NewsItem): NewsItem => {
      newsItem.News_Date = moment(newsItem.News_Date).format('YYYY-MM-DD')
      return newsItem
    })
  }
}
const actions = <ActionTree<NewsState, any>>{
  loadNews (store: ActionContext<NewsState, any>): Promise<any> {
    return store.dispatch('user/hasPermission', { permissionType: constants.PERMISSION_TYPES.SPLIT_NEWS, permissionValue: constants.PERMISSION_VALUES.VIEW }, { root: true })
      .then((hasPermission): any => {
        if (!hasPermission) {
          return Promise.resolve('not needed')
        } else {
          return webApi.split_news.get_internal_News().then((response: AxiosResponse) => {
            store.commit('setNews', response.data)
            return Promise.resolve()
          }).catch((error) => {
            return Promise.reject(error)
          })
        }
      })
  }
}
const getters = <GetterTree<NewsState, any>>{
  newNewsCount (state: NewsState): number {
    return filter(state.news, { New_News: true }).length
  }
}
export default ({
  namespaced: true,
  state: new NewsState(),
  mutations,
  actions,
  getters
})
